/** Maximum length of a snapshot description, enforced by the preview and panel editors. */
export const SNAPSHOT_DESCRIPTION_MAX_LENGTH = 500;
